import { useState } from "react";
import { Tabs } from "../../../../components/common/Tabs";
import { useTheme } from "../../../../components/hooks/useTheme";
import ReturnTemplates from "./ReturnTemplates";
import GeneralSettings from "./GeneralSettings";

const tabs = [
  {
    label: "Return Receipt",
  },
  {
    label: "General Settings",
  },
]

export const ReturnReceipt = () => {
  const { themeStyles } = useTheme();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const hanbleTabChange = (index: number) => {
    setActiveIndex(index);
  }

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <h1 className={`m-1 ${themeStyles.main.textHeadingColor}`}>Return Receipt Settings</h1>

        <div className="w-full mt-2">
          <Tabs tabs={tabs} onChange={(index) => hanbleTabChange(index)} activeIndex={activeIndex} />
        </div>

        <div>
          {activeIndex === 0 && <ReturnTemplates />}
          {activeIndex === 1 && <GeneralSettings />}
        </div>
      </div>
    </div>

  )
}

